const tokenKey = "rentpilot_admin_token";

export const saveToken = async (token: string): Promise<void> => {
  localStorage.setItem(tokenKey, token);
};

export const getToken = async (): Promise<string | null> => {
  return localStorage.getItem(tokenKey);
};

export const removeToken = async (): Promise<void> => {
  localStorage.removeItem(tokenKey);
};
